<template>
  <div class="fill-height">
    <line-chart
      v-if="viewMode === 'chart'"
      class="fill-height"
      type="bar"
      :raw-data="enjoymentDistribution"
      x-value="key"
      :chart-value-keys="[{ key: 'value', label: $t('variables.ENJY'), type: 'bar' }]"
      :yaxis="[{ labels: {
        formatter: function(value) {
          return value.toFixed(2);
        }
      } }]"
      :colors="['#FF4560']"
      :xaxis="{
        labels: {
          rotate: -45
        },
        categories: enjoymentDistribution.map(p => p.key),
        tickPlacement: 'between',
        title: { text: $t('variables.ENJY')}
      }"
    >
      <template v-slot:header>
        <v-card-title class="pa-6 d-flex justify-space-between">
          <div class="subtitle-2 grey--text text--grey-100">
            {{ $t('card_title.enjoyment_distribution') }}{{ aggregation ? ": " + $t(`variables.${aggregation}.long`) : '' }}
          </div>
          <v-btn
            v-if="removable"
            icon
            style="pointer-events: auto"
            @click="$emit('remove')"
          >
            <v-icon small>
              fal fa-times
            </v-icon>
          </v-btn>
          <visual-list-toggle
            v-else
            :value.sync="viewMode"
          />
        </v-card-title>
      </template>
    </line-chart>

    <v-card
      v-else-if="viewMode === 'table'"
      class="fill-height rounded-lg"
    >
      <v-card-title class="pa-6 d-flex justify-space-between">
        <div class="subtitle-2 grey--text text--grey-100">
          {{ $t('card_title.enjoyment_distribution') }}{{ aggregation ? ": " + $t(`variables.${aggregation}.long`) : '' }}
        </div>
        <div class="d-flex align-center">
          <visual-list-toggle
            v-if="!removable"
            :value.sync="viewMode"
          />
        </div>
      </v-card-title>

      <v-data-table
        :headers="tableHeaders"
        :items="enjoymentDistribution"
        hide-default-footer
        disable-pagination
        :items-per-page="-1"
        fixed-header
        dense
        :height="350"
      >
        <template v-slot:item.value="{ item }">
          {{ item.value.toFixed(2) }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart.vue'
import VisualListToggle from '@/components/buttons/VisualListToggle.vue'
import { calculateDistributionFromCounts } from '@/utils/helpers'

export default {
  name: 'EnjoymentDistributionChart',
  components: { LineChart, VisualListToggle },
  props: {
    players: {
      type: Array,
      required: true
    },
    stats: {
      type: [Object, Array],
      default: () => ({})
    },
    removable: {
      type: Boolean,
      default: false
    },
    aggregation: {
      type: String,
      default: null
    }
  },
  data: () => ({
    viewMode: 'chart'
  }),
  computed: {
    enjoymentDistribution() {
      const dist = (this.stats && this.stats.ENJY_dist) || []

      return calculateDistributionFromCounts(dist, 1, 5)
    },
    getKey() {
      return (baseKey) => this.aggregation && !this.removable ? `${baseKey}_${this.aggregation}` : baseKey
    },
    tableHeaders() {
      return [
        {
          text: this.$t('table_headers.enjoyment_level'),
          value: 'key',
          sortable: true,
          width: '60%'
        },
        {
          text: this.$t('table_headers.count'),
          value: 'value',
          sortable: true,
          align: 'center'
        }
      ]
    }
  }
}
</script>
